import React from "react";
import { Chart as ChartJS } from "chart.js/auto"; // Auto-registers all chart types
import { Chart } from "react-chartjs-2";

const CustomChart = ({
  type = "bar",
  xData = [],
  yData = [],
  label = "Dataset",
  color = "rgba(54, 162, 235, 0.5)", // default light blue
  horizontal = false,
  barGap = 0.8,
  placeholderColor = "rgba(200, 200, 200, 0.2)",
  showPlaceholder = true,
  yTicks = false,
}) => {
  const maxValue = Math.max(...yData, 1);

  // simple palette generator
  const generateColors = (count) => {
    const baseColors = [
      "rgba(255, 99, 132, 0.6)", // red
      "rgba(54, 162, 235, 0.6)", // blue
      "rgba(255, 206, 86, 0.6)", // yellow
      "rgba(75, 192, 192, 0.6)", // teal
      "rgba(153, 102, 255, 0.6)", // purple
      "rgba(255, 159, 64, 0.6)", // orange
    ];

    // repeat colors if more slices than baseColors
    return Array.from(
      { length: count },
      (_, i) => baseColors[i % baseColors.length]
    );
  };

  // Build datasets dynamically
  let datasets = [];

  // pie/doughnut dataset
  if (type === "pie" || type === "doughnut") {
     // use auto-generated colors
     const sliceColors = generateColors(xData.length);

    datasets = [
      {
        label,
        data: yData,
        backgroundColor: sliceColors,
        borderColor: sliceColors.map(c => c.replace("0.6", "1")), // solid border
        borderWidth: 1,
      },
    ];
  } else {
    datasets.push({
      label: label,
      data: yData,
      backgroundColor: color,
      borderColor: color.replace("0.5", "1"),
      borderWidth: 1,
      barPercentage: barGap,
      categoryPercentage: barGap,
      stack: "stack1",
    });
  }

  if (showPlaceholder) {
    datasets.push({
      label: "placeholder",
      data: new Array(xData.length).fill(maxValue),
      backgroundColor: placeholderColor,
      borderWidth: 0,
      barPercentage: barGap,
      categoryPercentage: barGap,
      stack: "stack1",
    });
  }

  const data = {
    labels: xData,
    datasets,
  };

  const options =
    type === "pie" || type === "doughnut"
      ? {
          responsive: true,
          plugins: {
            legend: { display: false, position: "top" },
            title: { display: false },
          },
        }
      : {
          indexAxis: horizontal ? "y" : "x", // horizontal if true
          responsive: true,
          plugins: {
            legend: { display: false, position: "top" }, //remove dataset toggle
            title: { display: false, text: `${label} Chart` }, // remoce chart name
          },
          scales: {
            x: {
              grid: { display: false }, // remove vertical gridlines
              ticks: { display: true }, // keep labels
              border: { display: false }, // hide x-axis line
              stacked: true,
              ...{ max: maxValue },
            },
            y: {
              grid: { display: false }, // remove horizontal gridlines
              ticks: { display: yTicks }, // keep labels
              border: { display: false }, // hide x-axis line
              stacked: true,
              ...{ max: maxValue },
            },
          },
        };

  return <Chart type={type} data={data} options={options} />;
};

export default CustomChart;
